import React, { useState , useEffect} from 'react';
import { AdminTopNav, AdminSideNav } from '../administrationNavigation/AdminConsoleNavigation';


const AdminDashboard = () => {
  return (
    <div className="main-window">
      <AdminTopNav />
      <div className="container-fluid">
        <div className="row">
          <AdminSideNav />
          <main className="col-12 col-md-9 col-lg-10 ms-sm-auto console-main-window"> 

           </main>
        </div>
      </div>

    </div>
  );
};

export default AdminDashboard;